import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BaseDirective } from '@shared/directives/base/base.directive';
import { LoaderComponent, ToastComponent } from 'cve-ui';
import { AmplitudeService } from './infrastructure/services/amplitude.service';
import { BreakpointService } from './infrastructure/services/breakpoint.service';
import { ClarityService } from './infrastructure/services/clarity.service';
import { GoogleAnalyticService } from './infrastructure/services/google-analytic.service';
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent, ToastComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent extends BaseDirective {
    breakpointService = inject(BreakpointService);
    googleAnalyticService = inject(GoogleAnalyticService);
    amplitudeService = inject(AmplitudeService);
    clarityService = inject(ClarityService);

    constructor() {
        super();
        this.breakpointService.set();
        this.googleAnalyticService.setup();
        this.amplitudeService.setup();
        // this.clarityService.setup();
    }
}
